module.exports = __webpack_public_path__ + "static/media/addAudio.af233755.svg";